module.exports = __webpack_public_path__ + "static/media/Hero1.a130b06b.mov";